// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"iJqzP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useListBox = require("react-aria/useListBox");
var _useListState = require("react-stately/useListState");
var _item = require("react-stately/Item");
var _useFocusRing = require("react-aria/useFocusRing");
var _mergeProps = require("react-aria/mergeProps");
var _useDraggableCollectionState = require("react-stately/useDraggableCollectionState");
var _useDraggableCollection = require("react-aria/useDraggableCollection");
var _useDrop = require("react-aria/useDrop");
var _useButton = require("react-aria/useButton");
var _themeCss = require("vanilla-starter/theme.css");
"use client";
function ListBox(props) {
    let state = (0, _useListState.useListState)(props);
    let ref = (0, _reactDefault.default).useRef(null);
    let { listBoxProps } = (0, _useListBox.useListBox)({
        ...props,
        shouldSelectOnPressUp: true
    }, state, ref);
    let dragState = (0, _useDraggableCollectionState.useDraggableCollectionState)({
        ...props,
        collection: state.collection,
        selectionManager: state.selectionManager,
        getItems: (keys)=>[
                ...keys
            ].map((key)=>({
                    'text/plain': state.collection.getItem(key)?.textValue ?? ''
                }))
    });
    (0, _useDraggableCollection.useDraggableCollection)(props, dragState, ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        ...listBoxProps,
        ref: ref,
        style: {
            padding: 0,
            margin: 0,
            listStyle: 'none',
            width: 180,
            border: '1px solid var(--gray-300)',
            borderRadius: 8,
            color: 'var(--text-color)'
        },
        children: [
            ...state.collection
        ].map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Option, {
                item: item,
                state: state,
                dragState: dragState
            }, item.key))
    });
}
function Option({ item, state, dragState }) {
    let ref = (0, _reactDefault.default).useRef(null);
    let { optionProps } = (0, _useListBox.useOption)({
        key: item.key
    }, state, ref);
    let { isFocusVisible, focusProps } = (0, _useFocusRing.useFocusRing)();
    let { dragProps } = (0, _useDraggableCollection.useDraggableItem)({
        key: item.key
    }, dragState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        ...(0, _mergeProps.mergeProps)(optionProps, dragProps, focusProps),
        ref: ref,
        style: {
            padding: '8px 12px',
            cursor: 'grab',
            outline: isFocusVisible ? '2px solid var(--focus-ring-color)' : 'none',
            outlineOffset: -2
        },
        children: item.rendered
    });
}
function DropTarget() {
    let [dropped, setDropped] = (0, _reactDefault.default).useState('');
    let ref = (0, _reactDefault.default).useRef(null);
    let { dropProps, isDropTarget } = (0, _useDrop.useDrop)({
        ref,
        async onDrop (e) {
            let texts = await Promise.all(e.items.map((item)=>item.kind === 'text' ? item.getText('text/plain') : null));
            setDropped(texts.filter(Boolean).join(', '));
        }
    });
    let { buttonProps } = (0, _useButton.useButton)({
        elementType: 'div'
    }, ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _mergeProps.mergeProps)(dropProps, buttonProps),
        ref: ref,
        style: {
            width: 180,
            height: 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 8,
            color: 'var(--text-color)',
            border: `2px dashed ${isDropTarget ? 'var(--focus-ring-color)' : 'var(--gray-300)'}`
        },
        children: dropped || 'Drop here'
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 16,
        alignItems: 'start'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListBox, {
            "aria-label": "Categories",
            selectionMode: "multiple",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _item.Item), {
                    children: "Animals"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _item.Item), {
                    children: "People"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _item.Item), {
                    children: "Plants"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DropTarget, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria/useListBox":[["useListBox","hOlJu"],["useOption","5s764"]],"react-stately/useListState":"fjFJL","react-stately/Item":"guJaC","react-aria/useFocusRing":"5qaYX","react-aria/mergeProps":"1CzGd","react-stately/useDraggableCollectionState":"blNTk","react-aria/useDraggableCollection":[["useDraggableCollection","gewhe"],["useDraggableItem","8NqhT"]],"react-aria/useDrop":"ejYww","react-aria/useButton":"3qP7L","vanilla-starter/theme.css":"bkMig","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"guJaC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>_Item);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Item(props) {
    return null;
}
Item.getCollectionNode = function* getCollectionNode(props, context) {
    let { childItems, title, children } = props;
    let rendered = props.title || props.children;
    let textValue = props.textValue || (typeof rendered === 'string' ? rendered : '') || props['aria-label'] || '';
    // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
    !textValue && context?.suppressTextValueWarning;
    yield {
        type: 'item',
        props: props,
        rendered,
        textValue,
        'aria-label': props['aria-label'],
        hasChildNodes: hasChildItems(props),
        *childNodes () {
            if (childItems) for (let child of childItems)yield {
                type: 'item',
                value: child
            };
            else if (title) {
                let items = [];
                (0, _reactDefault.default).Children.forEach(children, (child)=>{
                    items.push({
                        type: 'item',
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
function hasChildItems(props) {
    if (props.hasChildItems != null) return props.hasChildItems;
    if (props.childItems) return true;
    if (props.title && (0, _reactDefault.default).Children.count(props.children) > 0) return true;
    return false;
}
// We don't want getCollectionNode to show up in the type definition
let _Item = Item;

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"blNTk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for a draggable collection.
 */ parcelHelpers.export(exports, "useDraggableCollectionState", ()=>useDraggableCollectionState);
var _react = require("react");
function useDraggableCollectionState(props) {
    let { getItems, isDisabled, collection, selectionManager, onDragStart, onDragMove, onDragEnd, preview, getAllowedDropOperations } = props;
    let [, setDragging] = (0, _react.useState)(false);
    let draggingKeys = (0, _react.useRef)(new Set());
    let draggedKey = (0, _react.useRef)(null);
    let getKeys = (key)=>{
        // The clicked item is always added to the drag. If it is selected, then all of the
        // other selected items are also dragged. If it is not selected, then only the clicked
        // item is dragged. This matches native macOS behavior.
        // Additionally, we filter out any keys that are children of any of the other selected keys
        let keys = new Set();
        if (selectionManager.isSelected(key)) for (let currentKey of selectionManager.selectedKeys){
            let node = collection.getItem(currentKey);
            if (node) {
                let isChild = false;
                let parentKey = node.parentKey;
                while(parentKey != null){
                    // eslint-disable-next-line max-depth
                    if (selectionManager.selectedKeys.has(parentKey)) {
                        isChild = true;
                        break;
                    }
                    let parentNode = collection.getItem(parentKey);
                    parentKey = parentNode ? parentNode.parentKey : null;
                }
                if (!isChild) keys.add(currentKey);
            }
        }
        else keys.add(key);
        return keys;
    };
    return {
        collection,
        selectionManager,
        get draggedKey () {
            return draggedKey.current;
        },
        get draggingKeys () {
            return draggingKeys.current;
        },
        isDragging (key) {
            return draggingKeys.current.has(key);
        },
        getKeysForDrag: getKeys,
        getItems (key) {
            let keys = getKeys(key);
            let items = [];
            for (let key of keys){
                let value = collection.getItem(key)?.value;
                if (value != null) items.push(value);
            }
            return getItems(getKeys(key), items);
        },
        isDisabled,
        preview,
        getAllowedDropOperations,
        startDrag (key, event) {
            let keys = getKeys(key);
            draggingKeys.current = keys;
            draggedKey.current = key;
            selectionManager.setFocused(false);
            setDragging(true);
            if (typeof onDragStart === 'function') onDragStart({
                ...event,
                keys
            });
        },
        moveDrag (event) {
            if (typeof onDragMove === 'function') onDragMove({
                ...event,
                keys: draggingKeys.current
            });
        },
        endDrag (event) {
            let { isInternal } = event;
            if (typeof onDragEnd === 'function') onDragEnd({
                ...event,
                keys: draggingKeys.current,
                isInternal
            });
            draggingKeys.current = new Set();
            draggedKey.current = null;
            setDragging(false);
        }
    };
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gewhe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drag interactions for a collection component, with support for traditional mouse and
 * touch based drag and drop, in addition to full parity for keyboard and screen reader users.
 */ parcelHelpers.export(exports, "useDraggableCollection", ()=>useDraggableCollection);
var _utils = require("./utils");
function useDraggableCollection(props, state, ref) {
    // Update global DnD state if this keys within this collection are dragged
    let { draggingCollectionRef } = (0, _utils.globalDndState);
    if (state.draggingKeys.size > 0 && draggingCollectionRef?.current !== ref.current) (0, _utils.setDraggingCollectionRef)(ref);
}

},{"./utils":"hoHDi","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hoHDi":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "droppableCollectionMap", ()=>droppableCollectionMap);
parcelHelpers.export(exports, "DIRECTORY_DRAG_TYPE", ()=>DIRECTORY_DRAG_TYPE);
parcelHelpers.export(exports, "getDroppableCollectionId", ()=>getDroppableCollectionId);
parcelHelpers.export(exports, "getDroppableCollectionRef", ()=>getDroppableCollectionRef);
parcelHelpers.export(exports, "getTypes", ()=>getTypes);
parcelHelpers.export(exports, "useDragModality", ()=>useDragModality);
parcelHelpers.export(exports, "getDragModality", ()=>getDragModality);
parcelHelpers.export(exports, "writeToDataTransfer", ()=>writeToDataTransfer);
parcelHelpers.export(exports, "DragTypes", ()=>DragTypes);
parcelHelpers.export(exports, "readFromDataTransfer", ()=>readFromDataTransfer);
/** Returns whether a drop item contains text data. */ parcelHelpers.export(exports, "isTextDropItem", ()=>isTextDropItem);
/** Returns whether a drop item is a file. */ parcelHelpers.export(exports, "isFileDropItem", ()=>isFileDropItem);
/** Returns whether a drop item is a directory. */ parcelHelpers.export(exports, "isDirectoryDropItem", ()=>isDirectoryDropItem);
parcelHelpers.export(exports, "globalDndState", ()=>globalDndState);
parcelHelpers.export(exports, "setDraggingCollectionRef", ()=>setDraggingCollectionRef);
parcelHelpers.export(exports, "setDraggingKeys", ()=>setDraggingKeys);
parcelHelpers.export(exports, "setDropCollectionRef", ()=>setDropCollectionRef);
parcelHelpers.export(exports, "clearGlobalDnDState", ()=>clearGlobalDnDState);
parcelHelpers.export(exports, "setGlobalDnDState", ()=>setGlobalDnDState);
// Util function to check if the current dragging collection ref is the same as the current targeted droppable collection ref.
// Allows a droppable ref arg in case the global drop collection ref hasn't been set
parcelHelpers.export(exports, "isInternalDropOperation", ()=>isInternalDropOperation);
parcelHelpers.export(exports, "globalDropEffect", ()=>globalDropEffect);
parcelHelpers.export(exports, "setGlobalDropEffect", ()=>setGlobalDropEffect);
parcelHelpers.export(exports, "globalAllowedDropOperations", ()=>globalAllowedDropOperations);
parcelHelpers.export(exports, "setGlobalAllowedDropOperations", ()=>setGlobalAllowedDropOperations);
var _constants = require("./constants");
var _useFocusVisible = require("../interactions/useFocusVisible");
const droppableCollectionMap = new WeakMap();
const DIRECTORY_DRAG_TYPE = Symbol();
function getDroppableCollectionId(state) {
    let { id } = droppableCollectionMap.get(state) || {};
    if (!id) throw new Error('Droppable item outside a droppable collection');
    return id;
}
function getDroppableCollectionRef(state) {
    let { ref } = droppableCollectionMap.get(state) || {};
    if (!ref) throw new Error('Droppable item outside a droppable collection');
    return ref;
}
function getTypes(items) {
    let types = new Set();
    for (let item of items)for (let type of Object.keys(item))types.add(type);
    return types;
}
function mapModality(modality) {
    if (!modality) modality = 'virtual';
    if (modality === 'pointer') modality = 'virtual';
    if (modality === 'virtual' && typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches) modality = 'touch';
    return modality;
}
function useDragModality() {
    return mapModality((0, _useFocusVisible.useInteractionModality)());
}
function getDragModality() {
    return mapModality((0, _useFocusVisible.getInteractionModality)());
}
function writeToDataTransfer(dataTransfer, items) {
    // The data transfer API doesn't support more than one item of a given type at once.
    // In addition, only a small set of types are supported natively for transfer between applications.
    // We allow for both multiple items, as well as multiple representations of a single item.
    // In order to make our API work with the native API, we serialize all items to JSON and
    // store as a single native item. We only need to do this if there is more than one item
    // of the same type, or if an item has more than one representation. Otherwise the native
    // API is sufficient.
    //
    // The DataTransferItemList API also theoretically supports adding files, which would enable
    // dragging binary data out of the browser onto the user's desktop for example. Unfortunately,
    // this does not currently work in any browser, so it is not currently supported by our API.
    // See e.g. https://bugs.chromium.org/p/chromium/issues/detail?id=438479.
    let groupedByType = new Map();
    let needsCustomData = false;
    let customData = [];
    for (let item of items){
        let types = Object.keys(item);
        if (types.length > 1) needsCustomData = true;
        let dataByType = {};
        for (let type of types){
            let typeItems = groupedByType.get(type);
            if (!typeItems) {
                typeItems = [];
                groupedByType.set(type, typeItems);
            } else needsCustomData = true;
            let data = item[type];
            dataByType[type] = data;
            typeItems.push(data);
        }
        customData.push(dataByType);
    }
    for (let [type, items] of groupedByType)if ((0, _constants.NATIVE_DRAG_TYPES).has(type)) {
        // Only one item of a given type can be set on a data transfer.
        // Join all of the items together separated by newlines.
        let data = items.join('\n');
        dataTransfer.items.add(data, type);
    } else // Set data to the first item so we have access to the list of types.
    dataTransfer.items.add(items[0], type);
    if (needsCustomData) {
        let data = JSON.stringify(customData);
        dataTransfer.items.add(data, (0, _constants.CUSTOM_DRAG_TYPE));
    }
}
class DragTypes {
    constructor(dataTransfer){
        this.types = new Set();
        let hasFiles = false;
        for (let item of dataTransfer.items)if (item.type !== (0, _constants.CUSTOM_DRAG_TYPE)) {
            if (item.kind === 'file') hasFiles = true;
            if (item.type) this.types.add(item.type);
            else // Files with unknown types or extensions that don't map to a known mime type
            // are sometimes exposed as an empty string by the browser. Map to a generic
            // mime type instead. Note that this could also be a directory as there's no
            // way to determine if something is a file or directory until drop.
            this.types.add((0, _constants.GENERIC_TYPE));
        }
        // In Safari, when dragging files, the dataTransfer.items list is empty, but dataTransfer.types contains "Files".
        // Unfortunately, this doesn't tell us what types of files the user is dragging, so we need to assume that any
        // type the user checks for is included. See https://bugs.webkit.org/show_bug.cgi?id=223517.
        this.includesUnknownTypes = !hasFiles && dataTransfer.types.includes('Files');
    }
    has(type) {
        if (Array.isArray(type)) return type.some((t)=>this.has(t));
        if (this.includesUnknownTypes || type === DIRECTORY_DRAG_TYPE && this.types.has((0, _constants.GENERIC_TYPE)) || type === '*/*') return true;
        if (typeof type === 'string') {
            if (type.endsWith('/*')) {
                for (let key of this.types){
                    if (key.startsWith(type.slice(0, -2))) return true;
                }
                return false;
            }
            return this.types.has(type);
        }
        return false;
    }
}
function readFromDataTransfer(dataTransfer) {
    let items = [];
    if (!dataTransfer) return items;
    // If our custom drag type is available, use that. This is a JSON serialized
    // representation of all items in the drag, set when there are multiple items
    // of the same type, or an individual item has multiple representations.
    let hasCustomType = false;
    if (dataTransfer.types.includes((0, _constants.CUSTOM_DRAG_TYPE))) try {
        let data = dataTransfer.getData((0, _constants.CUSTOM_DRAG_TYPE));
        let parsed = JSON.parse(data);
        for (let item of parsed)items.push({
            kind: 'text',
            types: new Set(Object.keys(item)),
            getText: (type)=>Promise.resolve(item[type])
        });
        hasCustomType = true;
    } catch  {
    // ignore
    }
    // Otherwise, map native drag items to items of a single representation.
    if (!hasCustomType) {
        let stringItems = new Map();
        for (let item of dataTransfer.items){
            if (item.kind === 'string') // The data for all formats must be read here because the data transfer gets
            // cleared out after the event handler finishes. If the item has an empty string
            // as a type, the mime type is unknown. Map to a generic mime type instead.
            stringItems.set(item.type || (0, _constants.GENERIC_TYPE), dataTransfer.getData(item.type));
            else if (item.kind === 'file') {
                // Despite the name, webkitGetAsEntry is also implemented in Firefox and Edge.
                // In the future, we may use getAsFileSystemHandle instead, but that's currently
                // only implemented in Chrome.
                if (typeof item.webkitGetAsEntry === 'function') {
                    let entry = item.webkitGetAsEntry();
                    // eslint-disable-next-line max-depth
                    if (!entry) continue;
                    // eslint-disable-next-line max-depth
                    if (entry.isFile) items.push(createFileItem(item.getAsFile()));
                    else if (entry.isDirectory) items.push(createDirectoryItem(entry));
                } else // Assume it's a file.
                items.push(createFileItem(item.getAsFile()));
            }
        }
        // All string items are different representations of the same item. There's no way to have
        // multiple string items at once in the current DataTransfer API.
        if (stringItems.size > 0) items.push({
            kind: 'text',
            types: new Set(stringItems.keys()),
            getText: (type)=>Promise.resolve(stringItems.get(type))
        });
    }
    return items;
}
function blobToString(blob) {
    if (typeof blob.text === 'function') return blob.text();
    // Safari doesn't have the Blob#text() method yet...
    return new Promise((resolve, reject)=>{
        let reader = new FileReader();
        reader.onload = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(blob);
    });
}
function createFileItem(file) {
    if (!file) throw new Error('No file provided');
    return {
        kind: 'file',
        type: file.type || (0, _constants.GENERIC_TYPE),
        name: file.name,
        getText: ()=>blobToString(file),
        getFile: ()=>Promise.resolve(file)
    };
}
function createDirectoryItem(entry) {
    return {
        kind: 'directory',
        name: entry.name,
        getEntries: ()=>getEntries(entry)
    };
}
async function* getEntries(item) {
    let reader = item.createReader();
    // We must call readEntries repeatedly because there may be a limit to the
    // number of entries that are returned at once.
    let entries;
    do {
        entries = await new Promise((resolve, reject)=>{
            reader.readEntries(resolve, reject);
        });
        for (let entry of entries){
            if (entry.isFile) {
                let file = await getEntryFile(entry);
                yield createFileItem(file);
            } else if (entry.isDirectory) yield createDirectoryItem(entry);
        }
    }while (entries.length > 0);
}
function getEntryFile(entry) {
    return new Promise((resolve, reject)=>entry.file(resolve, reject));
}
function isTextDropItem(dropItem) {
    return dropItem.kind === 'text';
}
function isFileDropItem(dropItem) {
    return dropItem.kind === 'file';
}
function isDirectoryDropItem(dropItem) {
    return dropItem.kind === 'directory';
}
let globalDndState = {
    draggingKeys: new Set()
};
function setDraggingCollectionRef(ref) {
    globalDndState.draggingCollectionRef = ref;
}
function setDraggingKeys(keys) {
    globalDndState.draggingKeys = keys;
}
function setDropCollectionRef(ref) {
    globalDndState.dropCollectionRef = ref;
}
function clearGlobalDnDState() {
    globalDndState = {
        draggingKeys: new Set()
    };
}
function setGlobalDnDState(state) {
    globalDndState = state;
}
function isInternalDropOperation(ref) {
    let { draggingCollectionRef, dropCollectionRef } = globalDndState;
    return draggingCollectionRef?.current != null && draggingCollectionRef.current === (ref?.current || dropCollectionRef?.current);
}
let globalDropEffect;
function setGlobalDropEffect(dropEffect) {
    globalDropEffect = dropEffect;
}
let globalAllowedDropOperations = (0, _constants.DROP_OPERATION).none;
function setGlobalAllowedDropOperations(o) {
    globalAllowedDropOperations = o;
}

},{"./constants":"hohj5","../interactions/useFocusVisible":"9a2nM","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hohj5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DROP_OPERATION", ()=>DROP_OPERATION);
parcelHelpers.export(exports, "DROP_OPERATION_ALLOWED", ()=>DROP_OPERATION_ALLOWED);
parcelHelpers.export(exports, "EFFECT_ALLOWED", ()=>EFFECT_ALLOWED);
parcelHelpers.export(exports, "DROP_EFFECT_TO_DROP_OPERATION", ()=>DROP_EFFECT_TO_DROP_OPERATION);
parcelHelpers.export(exports, "DROP_OPERATION_TO_DROP_EFFECT", ()=>DROP_OPERATION_TO_DROP_EFFECT);
parcelHelpers.export(exports, "NATIVE_DRAG_TYPES", ()=>NATIVE_DRAG_TYPES);
parcelHelpers.export(exports, "CUSTOM_DRAG_TYPE", ()=>CUSTOM_DRAG_TYPE);
parcelHelpers.export(exports, "GENERIC_TYPE", ()=>GENERIC_TYPE);
var DROP_OPERATION = /*#__PURE__*/ function(DROP_OPERATION) {
    DROP_OPERATION[DROP_OPERATION["none"] = 0] = "none";
    DROP_OPERATION[DROP_OPERATION["cancel"] = 0] = "cancel";
    DROP_OPERATION[DROP_OPERATION["move"] = 1] = "move";
    DROP_OPERATION[DROP_OPERATION["copy"] = 2] = "copy";
    DROP_OPERATION[DROP_OPERATION["link"] = 4] = "link";
    DROP_OPERATION[DROP_OPERATION["all"] = 7] = "all";
    return DROP_OPERATION;
}({});
const DROP_OPERATION_ALLOWED = {
    ...DROP_OPERATION,
    copyMove: 3,
    copyLink: 6,
    linkMove: 5,
    all: 7,
    uninitialized: 7
};
const EFFECT_ALLOWED = invert(DROP_OPERATION_ALLOWED);
EFFECT_ALLOWED[7] = 'all'; // ensure we don't map to 'uninitialized'.
const DROP_EFFECT_TO_DROP_OPERATION = {
    none: 'cancel',
    link: 'link',
    copy: 'copy',
    move: 'move'
};
const DROP_OPERATION_TO_DROP_EFFECT = invert(DROP_EFFECT_TO_DROP_OPERATION);
function invert(object) {
    let res = {};
    for(let key in object)res[object[key]] = key;
    return res;
}
const NATIVE_DRAG_TYPES = new Set([
    'text/plain',
    'text/uri-list',
    'text/html'
]);
const CUSTOM_DRAG_TYPE = 'application/vnd.react-aria.items+json';
const GENERIC_TYPE = 'application/octet-stream';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8NqhT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drag interactions for an item within a draggable collection.
 */ parcelHelpers.export(exports, "useDraggableItem", ()=>useDraggableItem);
var _utils = require("./utils");
var _json = require("../../intl/dnd/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _useDescription = require("../utils/useDescription");
var _useDrag = require("./useDrag");
var _useLocalizedStringFormatter = require("../i18n/useLocalizedStringFormatter");
const MESSAGES = {
    keyboard: {
        selected: 'dragSelectedKeyboard',
        notSelected: 'dragDescriptionKeyboard'
    },
    touch: {
        selected: 'dragSelectedLongPress',
        notSelected: 'dragDescriptionLongPress'
    },
    virtual: {
        selected: 'dragDescriptionVirtual',
        notSelected: 'dragDescriptionVirtual'
    }
};
function useDraggableItem(props, state) {
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/dnd');
    let isDisabled = state.isDisabled || state.selectionManager.isDisabled(props.key);
    let { dragProps, dragButtonProps } = (0, _useDrag.useDrag)({
        getItems () {
            return state.getItems(props.key);
        },
        preview: state.preview,
        getAllowedDropOperations: state.getAllowedDropOperations,
        hasDragButton: props.hasDragButton,
        onDragStart (e) {
            state.startDrag(props.key, e);
            // Track draggingKeys for useDroppableCollection's default onDrop handler and useDroppableCollectionState's default getDropOperation
            (0, _utils.setDraggingKeys)(state.draggingKeys);
        },
        onDragMove (e) {
            state.moveDrag(e);
        },
        onDragEnd (e) {
            let { dropOperation } = e;
            let isInternal = dropOperation === 'cancel' ? false : (0, _utils.isInternalDropOperation)();
            state.endDrag({
                ...e,
                keys: state.draggingKeys,
                isInternal
            });
            (0, _utils.clearGlobalDnDState)();
        }
    });
    let item = state.collection.getItem(props.key);
    let numKeysForDrag = state.getKeysForDrag(props.key).size;
    let isSelected = numKeysForDrag > 1 && state.selectionManager.isSelected(props.key);
    let dragButtonLabel;
    let description;
    // Override description to include selected item count.
    let modality = (0, _utils.useDragModality)();
    if (!props.hasDragButton && state.selectionManager.selectionMode !== 'none') {
        let msg = MESSAGES[modality][isSelected ? 'selected' : 'notSelected'];
        if (props.hasAction && modality === 'keyboard') msg += 'Alt';
        if (isSelected) description = stringFormatter.format(msg, {
            count: numKeysForDrag
        });
        else description = stringFormatter.format(msg);
        // Remove the onClick handler from useDrag. Long pressing will be required on touch devices,
        // and NVDA/JAWS are always in forms mode within collection components.
        // oxlint-disable-next-line react/react-compiler
        delete dragProps.onClick;
    } else if (isSelected) dragButtonLabel = stringFormatter.format('dragSelectedItems', {
        count: numKeysForDrag
    });
    else {
        let itemText = state.collection.getTextValue?.(props.key) ?? item?.textValue ?? '';
        dragButtonLabel = stringFormatter.format('dragItem', {
            itemText
        });
    }
    let descriptionProps = (0, _useDescription.useDescription)(description);
    if (description) Object.assign(dragProps, descriptionProps);
    if (!props.hasDragButton && props.hasAction) {
        let { onKeyDownCapture, onKeyUpCapture } = dragProps;
        if (modality === 'touch') // Remove long press description if an action is present, because in that case long pressing selects the item.
        // oxlint-disable-next-line react/react-compiler
        delete dragProps['aria-describedby'];
        // Require Alt key if there is a conflicting action.
        // oxlint-disable-next-line react/react-compiler
        dragProps.onKeyDownCapture = (e)=>{
            if (e.altKey) onKeyDownCapture?.(e);
        };
        // oxlint-disable-next-line react/react-compiler
        dragProps.onKeyUpCapture = (e)=>{
            if (e.altKey) onKeyUpCapture?.(e);
        };
    }
    return {
        dragProps: isDisabled ? {} : dragProps,
        dragButtonProps: {
            ...dragButtonProps,
            isDisabled,
            'aria-label': dragButtonLabel
        }
    };
}

},{"./utils":"hoHDi","../../intl/dnd/*.json":"jwYGj","../utils/useDescription":"3ThWR","./useDrag":"dQp85","../i18n/useLocalizedStringFormatter":"4LM0k","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dQp85":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drag interactions for an element, with support for traditional mouse and touch
 * based drag and drop, in addition to full parity for keyboard and screen reader users.
 */ parcelHelpers.export(exports, "useDrag", ()=>useDrag);
var _react = require("react");
var _dragManager = require("./DragManager");
var _constants = require("./constants");
var _domfunctions = require("../utils/shadowdom/DOMFunctions");
var _utils = require("./utils");
var _json = require("../../intl/dnd/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _platform = require("../utils/platform");
var _isVirtualEvent = require("../utils/isVirtualEvent");
var _useDescription = require("../utils/useDescription");
var _useGlobalListeners = require("../utils/useGlobalListeners");
var _useLocalizedStringFormatter = require("../i18n/useLocalizedStringFormatter");
const MESSAGES = {
    keyboard: {
        start: 'dragDescriptionKeyboard',
        end: 'endDragKeyboard'
    },
    touch: {
        start: 'dragDescriptionTouch',
        end: 'endDragTouch'
    },
    virtual: {
        start: 'dragDescriptionVirtual',
        end: 'endDragVirtual'
    }
};
function useDrag(options) {
    let { hasDragButton, isDisabled } = options;
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/dnd');
    // oxlint-disable-next-line react/react-compiler
    let state = (0, _react.useRef)({
        options,
        x: 0,
        y: 0
    }).current;
    state.options = options;
    let isDraggingRef = (0, _react.useRef)(null);
    let [isDragging, setDraggingState] = (0, _react.useState)(false);
    let setDragging = (element)=>{
        isDraggingRef.current = element;
        setDraggingState(!!element);
    };
    let { addGlobalListener, removeAllGlobalListeners } = (0, _useGlobalListeners.useGlobalListeners)();
    let modalityOnPointerDown = (0, _react.useRef)(null);
    let onDragStart = (e)=>{
        if (e.defaultPrevented) return;
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        // If this drag was initiated by a mobile screen reader (e.g. VoiceOver or TalkBack), enter virtual dragging mode.
        if (modalityOnPointerDown.current === 'virtual') {
            e.preventDefault();
            startDragging((0, _domfunctions.getEventTarget)(e));
            modalityOnPointerDown.current = null;
            return;
        }
        if (typeof options.onDragStart === 'function') options.onDragStart({
            type: 'dragstart',
            x: e.clientX,
            y: e.clientY
        });
        let items = options.getItems();
        // Clear existing data (e.g. selected text on the page would be included in some browsers)
        e.dataTransfer.clearData?.();
        (0, _utils.writeToDataTransfer)(e.dataTransfer, items);
        let allowed = (0, _constants.DROP_OPERATION).all;
        if (typeof options.getAllowedDropOperations === 'function') {
            let allowedOperations = options.getAllowedDropOperations();
            allowed = (0, _constants.DROP_OPERATION).none;
            for (let operation of allowedOperations)allowed |= (0, _constants.DROP_OPERATION)[operation] || (0, _constants.DROP_OPERATION).none;
        }
        (0, _utils.setGlobalAllowedDropOperations)(allowed);
        let effectAllowed = (0, _constants.EFFECT_ALLOWED)[allowed] || 'none';
        e.dataTransfer.effectAllowed = effectAllowed === 'cancel' ? 'none' : effectAllowed;
        // If there is a preview option, use it to render a custom preview image that will
        // appear under the pointer while dragging. If not, the element itself is dragged by the browser.
        if (typeof options.preview?.current === 'function') options.preview.current(items, (node, userX, userY)=>{
            if (!node) return;
            // Compute the offset that the preview will appear under the mouse.
            // If possible, this is based on the point the user clicked on the target.
            // If the preview is much smaller, then just use the center point of the preview.
            let size = node.getBoundingClientRect();
            let rect = e.currentTarget.getBoundingClientRect();
            let defaultX = e.clientX - rect.x;
            let defaultY = e.clientY - rect.y;
            if (defaultX > size.width || defaultY > size.height) {
                defaultX = size.width / 2;
                defaultY = size.height / 2;
            }
            // Start with default offsets.
            let offsetX = defaultX;
            let offsetY = defaultY;
            // If the preview renderer supplied explicit offsets, use those.
            if (typeof userX === 'number' && typeof userY === 'number') {
                offsetX = userX;
                offsetY = userY;
            }
            // Clamp the offset so it stays within the preview bounds. Browsers
            // automatically clamp out-of-range values, but doing it ourselves
            // prevents the visible "snap" that can occur when the browser adjusts
            // them after the first drag update.
            offsetX = Math.max(0, Math.min(offsetX, size.width));
            offsetY = Math.max(0, Math.min(offsetY, size.height));
            // Rounding height to an even number prevents blurry preview seen on some screens
            let height = 2 * Math.round(size.height / 2);
            node.style.height = `${height}px`;
            e.dataTransfer.setDragImage(node, offsetX, offsetY);
        });
        // Enforce that drops are handled by useDrop.
        addGlobalListener(window, 'drop', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            console.warn('Drags initiated from the React Aria useDrag hook may only be dropped on a target created with useDrop. This ensures that a keyboard and screen reader accessible alternative is available.');
        }, {
            once: true
        });
        state.x = e.clientX;
        state.y = e.clientY;
        // Wait a frame before we set dragging to true so that the browser has time to
        // render the preview image before we update the element that has been dragged.
        let target = (0, _domfunctions.getEventTarget)(e);
        requestAnimationFrame(()=>{
            setDragging(target);
        });
    };
    let onDrag = (e)=>{
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        if (e.clientX === state.x && e.clientY === state.y) return;
        if (typeof options.onDragMove === 'function') options.onDragMove({
            type: 'dragmove',
            x: e.clientX,
            y: e.clientY
        });
        state.x = e.clientX;
        state.y = e.clientY;
    };
    let onDragEnd = (e)=>{
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        if (typeof options.onDragEnd === 'function') {
            let event = {
                type: 'dragend',
                x: e.clientX,
                y: e.clientY,
                dropOperation: (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[e.dataTransfer.dropEffect]
            };
            // Chrome Android always returns none as its dropEffect so we use the drop effect set in useDrop via
            // onDragEnter/onDragOver instead. https://bugs.chromium.org/p/chromium/issues/detail?id=1353951
            if (0, _utils.globalDropEffect) event.dropOperation = (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[0, _utils.globalDropEffect];
            options.onDragEnd(event);
        }
        setDragging(null);
        removeAllGlobalListeners();
        (0, _utils.setGlobalAllowedDropOperations)((0, _constants.DROP_OPERATION).none);
        (0, _utils.setGlobalDropEffect)(undefined);
    };
    // If the dragged element is removed from the DOM via onDrop, onDragEnd won't fire: https://bugzilla.mozilla.org/show_bug.cgi?id=460801
    // In this case, we need to manually call onDragEnd on cleanup
    (0, _react.useEffect)(()=>{
        return ()=>{
            // Check that the dragged element has actually unmounted from the DOM and not a React Strict Mode false positive.
            // https://github.com/facebook/react/issues/29585
            // React 16 ran effect cleanups before removing elements from the DOM but did not have this issue.
            if (isDraggingRef.current && (!isDraggingRef.current.isConnected || parseInt((0, _react.version), 10) < 17)) {
                if (typeof state.options.onDragEnd === 'function') {
                    let event = {
                        type: 'dragend',
                        x: 0,
                        y: 0,
                        dropOperation: (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[(0, _utils.globalDropEffect) || 'none']
                    };
                    state.options.onDragEnd(event);
                }
                setDragging(null);
                (0, _utils.setGlobalAllowedDropOperations)((0, _constants.DROP_OPERATION).none);
                (0, _utils.setGlobalDropEffect)(undefined);
            }
        };
    }, [
        state
    ]);
    let onPress = (e)=>{
        if (e.pointerType !== 'keyboard' && e.pointerType !== 'virtual') return;
        startDragging(e.target);
    };
    let startDragging = (target)=>{
        if (typeof state.options.onDragStart === 'function') {
            let rect = target.getBoundingClientRect();
            state.options.onDragStart({
                type: 'dragstart',
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2
            });
        }
        _dragManager.beginDragging({
            element: target,
            items: state.options.getItems(),
            allowedDropOperations: typeof state.options.getAllowedDropOperations === 'function' ? state.options.getAllowedDropOperations() : [
                'move',
                'copy',
                'link'
            ],
            onDragEnd (e) {
                setDragging(null);
                if (typeof state.options.onDragEnd === 'function') state.options.onDragEnd(e);
            }
        }, stringFormatter);
        setDragging(target);
    };
    let modality = (0, _utils.useDragModality)();
    let message = !isDragging ? MESSAGES[modality].start : MESSAGES[modality].end;
    let descriptionProps = (0, _useDescription.useDescription)(stringFormatter.format(message));
    let interactions = {};
    if (!hasDragButton) // If there's no separate button to trigger accessible drag and drop mode,
    // then add event handlers to the draggable element itself to start dragging.
    // For keyboard, we use the Enter key in a capturing listener to prevent other
    // events such as selection from also occurring. We attempt to infer whether a
    // pointer event (e.g. long press) came from a touch screen reader, and then initiate
    // dragging in the native onDragStart listener above.
    interactions = {
        ...descriptionProps,
        onPointerDown (e) {
            modalityOnPointerDown.current = (0, _isVirtualEvent.isVirtualPointerEvent)(e.nativeEvent) ? 'virtual' : e.pointerType;
            // Try to detect virtual drag passthrough gestures.
            if (e.width < 1 && e.height < 1 && (0, _platform.isIOS)() && (0, _platform.isWebKit)()) // iOS VoiceOver.
            modalityOnPointerDown.current = 'virtual';
            else {
                let rect = e.currentTarget.getBoundingClientRect();
                let offsetX = e.clientX - rect.x;
                let offsetY = e.clientY - rect.y;
                let centerX = rect.width / 2;
                let centerY = rect.height / 2;
                if (Math.abs(offsetX - centerX) <= 0.5 && Math.abs(offsetY - centerY) <= 0.5) // Android TalkBack.
                modalityOnPointerDown.current = 'virtual';
                else modalityOnPointerDown.current = e.pointerType;
            }
        },
        onKeyDownCapture (e) {
            if ((0, _domfunctions.getEventTarget)(e) === e.currentTarget && e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        onKeyUpCapture (e) {
            if ((0, _domfunctions.getEventTarget)(e) === e.currentTarget && e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                startDragging((0, _domfunctions.getEventTarget)(e));
            }
        },
        onClick (e) {
            // Handle NVDA/JAWS in browse mode, and touch screen readers. In this case, no keyboard events are fired.
            if ((0, _isVirtualEvent.isVirtualClick)(e.nativeEvent) || modalityOnPointerDown.current === 'virtual') {
                e.preventDefault();
                e.stopPropagation();
                startDragging((0, _domfunctions.getEventTarget)(e));
            }
        }
    };
    if (isDisabled) return {
        dragProps: {
            draggable: 'false'
        },
        dragButtonProps: {},
        isDragging: false
    };
    return {
        dragProps: {
            ...interactions,
            draggable: 'true',
            onDragStart,
            onDrag,
            onDragEnd
        },
        dragButtonProps: {
            ...descriptionProps,
            onPress
        },
        isDragging
    };
}

},{"react":"a1TxN","./DragManager":"i8OGd","./constants":"hohj5","../utils/shadowdom/DOMFunctions":"93ERU","./utils":"hoHDi","../../intl/dnd/*.json":"jwYGj","../utils/platform":"hqE84","../utils/isVirtualEvent":"4DFYe","../utils/useDescription":"3ThWR","../utils/useGlobalListeners":"8R0Wz","../i18n/useLocalizedStringFormatter":"4LM0k","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bkMig":[function() {},{}],"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _link = require("react-aria-components/Link");
var _skeleton = require("./Skeleton");
var _useDOMRef = require("./useDOMRef");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf16';
    else rules += ' _Le16';
    if (props.isStaticColor) rules += ' Oe16';
    else rules += ' Oh16';
    rules += ' OlOVIhfcebS7sd16';
    rules += ' OlOVIhfcebS7sd16';
    rules += ' _Mc16';
    rules += ' _Kd16';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr16';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s16';
    rules += ' oR3ltQc16';
    rules += ' nR3ltQc16';
    rules += ' kR3ltQc16';
    rules += ' jR3ltQc16';
    if (props.isStandalone) {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c16';
        rules += ' vFHT6Dd16';
    }
    if (props.isStandalone) {
        rules += ' xc16';
        rules += ' _xa16';
    }
    if (props.isStandalone) {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    }
    if (props.isStaticColor) rules += ' pl16';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po16';
        else if (props.isFocusVisible) rules += ' po16';
        else if (props.isHovered) rules += ' po16';
        else rules += ' pt16';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps16';
        else if (props.isFocusVisible) rules += ' ps16';
        else if (props.isHovered) rules += ' ps16';
        else rules += ' pu16';
    }
    rules += ' plOVIhfcA5Qiqd16';
    rules += ' plOVIhfcA5Qiqd16';
    rules += ' Yd16';
    rules += ' Xb16';
    rules += ' _2b16';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb16';
                rules += ' __Va16';
            } else if (props.isHovered) {
                rules += ' _Xb16';
                rules += ' __Va16';
            } else rules += ' _Xa16';
        }
    } else {
        rules += ' _Xb16';
        rules += ' __Va16';
    }
    rules += ' __ca16';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _useDOMRef.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components/Link":"fOCdV","./Skeleton":"1mUnF","./useDOMRef":"9tqah","react-aria/private/utils/useLayoutEffect":"k6VV7","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _slots = require("react-aria-components/slots");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _icon = require("./Icon");
var _text = require("react-aria-components/Text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _useDOMRef = require("./useDOMRef");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else if (props.size === "L") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else if (props.size === "S") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else if (props.size === "XS") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e16';
        rules += ' vFHT6Dd16';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d16';
        rules += ' vFHT6Dd16';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b16';
        rules += ' vFHT6Dd16';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a16';
        rules += ' vFHT6Dd16';
    } else {
        rules += ' -_6BNtrc-c16';
        rules += ' vFHT6Dd16';
    }
    if (props.size === "XL") {
        rules += ' xb16';
        rules += ' _xa16';
    } else if (props.size === "L") {
        rules += ' xb16';
        rules += ' _xa16';
    } else if (props.size === "S") {
        rules += ' xb16';
        rules += ' _xa16';
    } else if (props.size === "XS") {
        rules += ' xb16';
        rules += ' _xa16';
    } else {
        rules += ' xb16';
        rules += ' _xa16';
    }
    if (props.size === "XL") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else if (props.size === "L") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else if (props.size === "S") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else if (props.size === "XS") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    }
    if (props.fillStyle === "outline") rules += ' pm16';
    else if (props.fillStyle === "subtle") rules += ' pm16';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg16';
        else if (props.variant === "chartreuse") rules += ' pg16';
        else if (props.variant === "yellow") rules += ' pg16';
        else if (props.variant === "orange") rules += ' pg16';
        else if (props.variant === "notice") rules += ' pg16';
        else rules += ' px16';
    }
    rules += ' sd16';
    rules += ' ea16';
    rules += ' egLWx3bb16';
    rules += ' _oa16';
    rules += ' Sv16';
    rules += ' SgLWx3bd16';
    rules += ' Rv16';
    rules += ' RgLWx3bd16';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc16';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG16';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c16';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc16';
    } else if (!minWidth) rules += ' N4dY0ec16';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec16';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn16';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b16';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd16';
    else rules += ' -SFnbic-_Jb16';
    rules += ' -Bu7z1c-oH5kTnc16';
    rules += ' oj16';
    rules += ' nj16';
    rules += ' kj16';
    rules += ' jj16';
    rules += ' qc16';
    rules += ' qsd16';
    rules += ' -Qg41Lb-IAxCW0c16';
    rules += ' -Qg41Lb-gLWx3bIYB8I16';
    rules += ' MAyFGYc16';
    rules += ' Td16';
    rules += ' Qd16';
    rules += ' -aRvJDd-Tu7Fubd16';
    rules += ' _Ca16';
    if (props.fillStyle === "outline") rules += ' g_g16';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f16';
        else if (props.variant === "cinnamon") rules += ' gP16';
        else if (props.variant === "brown") rules += ' gO16';
        else if (props.variant === "turquoise") rules += ' gy16';
        else if (props.variant === "pink") rules += ' gT16';
        else if (props.variant === "magenta") rules += ' gS16';
        else if (props.variant === "fuchsia") rules += ' gR16';
        else if (props.variant === "purple") rules += ' gM16';
        else if (props.variant === "indigo") rules += ' gK16';
        else if (props.variant === "blue") rules += ' gG16';
        else if (props.variant === "cyan") rules += ' gC16';
        else if (props.variant === "seafoam") rules += ' gz16';
        else if (props.variant === "green") rules += ' gA16';
        else if (props.variant === "celery") rules += ' gv16';
        else if (props.variant === "chartreuse") rules += ' gJ16';
        else if (props.variant === "yellow") rules += ' gW16';
        else if (props.variant === "orange") rules += ' gV16';
        else if (props.variant === "red") rules += ' gU16';
        else if (props.variant === "gray") rules += ' gI16';
        else if (props.variant === "negative") rules += ' gU16';
        else if (props.variant === "notice") rules += ' gV16';
        else if (props.variant === "positive") rules += ' gA16';
        else if (props.variant === "neutral") rules += ' gI16';
        else if (props.variant === "informative") rules += ' gG16';
        else if (props.variant === "accent") rules += ' gG16';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm16';
        else if (props.variant === "cinnamon") rules += ' gq16';
        else if (props.variant === "brown") rules += ' gn16';
        else if (props.variant === "turquoise") rules += ' g516';
        else if (props.variant === "pink") rules += ' gx16';
        else if (props.variant === "magenta") rules += ' gD16';
        else if (props.variant === "fuchsia") rules += ' gr16';
        else if (props.variant === "purple") rules += ' go16';
        else if (props.variant === "indigo") rules += ' gl16';
        else if (props.variant === "blue") rules += ' g216';
        else if (props.variant === "cyan") rules += ' gk16';
        else if (props.variant === "seafoam") rules += ' g416';
        else if (props.variant === "green") rules += ' g116';
        else if (props.variant === "celery") rules += ' g716';
        else if (props.variant === "chartreuse") rules += ' gp16';
        else if (props.variant === "yellow") rules += ' gN16';
        else if (props.variant === "orange") rules += ' gQ16';
        else if (props.variant === "red") rules += ' gB16';
        else if (props.variant === "gray") rules += ' g616';
        else if (props.variant === "negative") rules += ' gB16';
        else if (props.variant === "notice") rules += ' gQ16';
        else if (props.variant === "positive") rules += ' g116';
        else if (props.variant === "neutral") rules += ' g616';
        else if (props.variant === "informative") rules += ' g216';
        else if (props.variant === "accent") rules += ' g216';
    }
    rules += ' _jf16';
    rules += ' _kJ8iPYd16';
    rules += ' hXMFGYc16';
    rules += ' mc16';
    rules += ' lc16';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS16';
        else if (props.variant === "notice") rules += ' i9VrKkd16';
        else if (props.variant === "positive") rules += ' ip17Jm16';
        else if (props.variant === "neutral") rules += ' i0ruhAb16';
        else if (props.variant === "informative") rules += ' iG1ze4d16';
        else if (props.variant === "accent") rules += ' iG1ze4d16';
        else rules += ' iA16';
    } else rules += ' iA16';
    rules += ' -_8sjo0b-t5ZbAob16';
    if (props.size === "XL") rules += ' -M_-MBaYFfc16';
    else if (props.size === "L") rules += ' -M_-M3JjxG16';
    else if (props.size === "S") rules += ' -M_-MCe2o8c16';
    else if (props.size === "XS") rules += ' -M_-MifsFYc16';
    else rules += ' -M_-M4dY0ec16';
    rules += ' -_k_-_kc16';
    rules += ' -h_-hc16';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG16';
                        rules += ' QAzEcG16';
                        rules += ' _Jb16';
                        rules += ' _Nc16';
                        rules += ' Pc16';
                        rules += ' _Yb16';
                        if (props.overflowMode === "wrap") rules += ' _7b16';
                        else if (props.overflowMode === "truncate") rules += ' _7c16';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _text.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja16"
                    }),
                    styles: " ZuUmpre16 FuUmpre16 I67logd16 _va16"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _filterDOMProps.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components/slots":"bA6Cz","react-aria/filterDOMProps":"c0Owd","./Icon":"jQAJE","react-aria-components/Text":"jt9fm","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","./useDOMRef":"9tqah","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"jAv02":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.78c-4.825 0-8.75-3.926-8.75-8.75S5.175 1.28 10 1.28s8.75 3.924 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.251-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.253 7.25-7.25S13.998 2.78 10 2.78"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 14.384c0 .653.615 1.121 1.251.973 2.435-.566 4.249-2.75 4.249-5.357s-1.814-4.79-4.249-5.357c-.636-.148-1.251.32-1.251.973z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8rFkP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M10 6.35c2.012 0 3.65 1.638 3.65 3.65s-1.638 3.65-3.65 3.65S6.35 12.012 6.35 10 7.988 6.35 10 6.35m0-1.5c-2.84 0-5.15 2.31-5.15 5.15s2.31 5.15 5.15 5.15 5.15-2.31 5.15-5.15S12.84 4.85 10 4.85M10 3.25c-.414 0-.75-.336-.75-.75V1.25c0-.414.336-.75.75-.75s.75.336.75.75V2.5c0 .414-.336.75-.75.75M10 19.5c-.414 0-.75-.336-.75-.75V17.5c0-.414.336-.75.75-.75s.75.336.75.75v1.25c0 .414-.336.75-.75.75M2.5 10.75H1.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75H2.5c.414 0 .75.336.75.75s-.336.75-.75.75M18.75 10.75H17.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25c.414 0 .75.336.75.75s-.336.75-.75.75M15.304 5.446c-.193 0-.384-.073-.53-.22-.294-.292-.294-.767 0-1.06l.883-.884c.293-.293.768-.293 1.06 0s.294.768 0 1.06l-.883.885c-.146.146-.338.22-.53.22M3.813 16.938c-.193 0-.384-.074-.53-.22-.294-.293-.294-.768 0-1.06l.883-.885c.293-.293.768-.293 1.06 0s.294.768 0 1.061l-.883.884c-.147.146-.338.22-.53.22M4.696 5.446c-.192 0-.383-.073-.53-.22l-.884-.883c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l.885.883c.293.293.293.768 0 1.06-.147.147-.338.22-.53.22M16.188 16.938c-.193 0-.384-.074-.53-.22l-.885-.884c-.293-.293-.293-.768 0-1.06s.768-.294 1.061 0l.884.883c.293.293.293.768 0 1.06-.147.147-.338.22-.53.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=useDraggableCollection.a3069f70.js.map
